<template>
  <div class="benefits-wrapper">
    <div class="section-heading">
      {{ benefitsText.pageHeading }}
    </div>
    <div class="d-flex justify-content-between mt-3 benefit-container">
      <div class="benefit-block">
        <img
          src="@/assets/images/common/best-forex-rates.svg"
          alt="Error Icon"
          height="20"
          class="mr-2"
        />
        {{ benefitsText.forex }}
      </div>
      <div class="divider"></div>
      <div class="benefit-block">
        <img
          src="@/assets/images/common/no-wire-fees.svg"
          alt="Error Icon"
          height="20"
          class="mr-2"
        />
        {{ benefitsText.wireFees }}
      </div>
      <div class="divider"></div>
      <div class="benefit-block">
        <img
          src="@/assets/images/common/rtgs-payments.svg"
          alt="Error Icon"
          height="20"
          class="mr-2"
        />
        {{ benefitsText.RtgsPayments }}
      </div>
      <div class="divider"></div>
      <div class="benefit-block">
        <img
          src="@/assets/images/common/hassle-free-process.svg"
          alt="Error Icon"
          height="20"
          class="mr-2"
        />
        {{ benefitsText.hassleFree }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    benefitsText() {
      return this.$t('account.index.currencySettings.benefits')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/variables';
@import '../../../assets/scss/palette';
.benefits-wrapper {
  margin-top: 32px;
  .section-heading {
    text-align: center;
    font-size: 1.25rem;
    font-weight: bold;
    color: map-get($noble-blue, 500);
    margin-bottom: 1rem;
  }
  .benefit-block {
    padding: 8px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    align-items: center;
    color: map-get($noble-blue, 500);
    font-weight: bold;
  }
  .divider {
    border-right: 1px solid map-get($noble-blue, 200);
  }
  .benefit-container {
    padding-bottom: 16px;
    border-bottom: 1px solid map-get($noble-blue, 200);
  }
}
@include media-breakpoint-down(md) {
  .benefit-container {
    flex-direction: column;
    align-items: center;
  }
  .benefit-block {
    margin-top: 10px;
    width: 100%;
  }
}
</style>
